import { useQuery } from '@apollo/client'
import {
  getPatients,
  getPatientsVariables,
  PatientStatus,
} from '../../models/graphqlTypes'
import { GET_PATIENTS_BY_DOCTOR } from '../../views/doctor/DoctorPatients/operations/doctorPatientOperations'

export const usePatientListTotal = ({
  doctorIds,
  status,
}: {
  doctorIds: getPatientsVariables['doctorIds']
  status: PatientStatus
}): { total: number; refetch: () => void } => {
  const { data, refetch } = useQuery<getPatients, getPatientsVariables>(
    GET_PATIENTS_BY_DOCTOR,
    {
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true,
      variables: {
        doctorIds,
        filterData: { status },
      },
    }
  )

  return { total: data?.listPatientsForDoctor.total ?? 0, refetch }
}
